export  function checkAll() {
    const checkAll = $(".check-all-box");
    const checkInputs = checkAll.find("input[type='checkbox']");
    const checkAllInput = checkAll.find(".check-all");

    checkInputs.on("change", function (e) {
        let counter = checkAll.find("input[type='checkbox']:checked").length;

        if($(e.target).hasClass("check-all")) {
            checkInputs.prop("checked", e.target.checked);
        } else {
            if (checkAllInput.prop("checked") || counter < $(checkInputs).length - 1) {
                checkAllInput.prop("checked", false);
            } else {
                checkAllInput.prop("checked", true);
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/checkAll.js